import React, { SVGProps } from 'react'

const ParticipantSelectEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M23.5 12c0 6.351-5.149 11.5-11.5 11.5S.5 18.351.5 12 5.649.5 12 .5 23.5 5.649 23.5 12Z" stroke="#BEBEBE" />
  </svg>
)

export default ParticipantSelectEmpty
